import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { ConfigServerService, CustomHttp } from '../../../core';
import { ItemLinha } from '../../item-linha';

@Injectable({
    providedIn: 'root'
})
export class UsuarioLinhaHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/usuario`
    }

    /** Pesquisa as linhas cadastradas para o usuário informado */
    searchLinhas(idUsuario: number): Observable<ItemLinha[]> {
        return this.customHttp.get<ItemLinha[]>(`${this.pathApi}/${idUsuario}/linha`);
    }

    /** Pesquisa as linhas cadastradas para o usuário logado */
    searchLinhasUsuarioLogado(): Observable<ItemLinha[]> {
        return this.customHttp.get<ItemLinha[]>(`${this.pathApi}/0/linha`);
    }
}
